import { render, staticRenderFns } from "./light.vue?vue&type=template&id=b96da970&scoped=true&"
import script from "./light.vue?vue&type=script&lang=js&"
export * from "./light.vue?vue&type=script&lang=js&"
import style0 from "./light.vue?vue&type=style&index=0&id=b96da970&lang=scss&scoped=true&"
import style1 from "./light.vue?vue&type=style&index=1&id=b96da970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96da970",
  null
  
)

export default component.exports